import React, { useReducer, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _clone from 'ramda/src/clone';
import _path from 'ramda/src/path';
import { RESX_GLOBAL, RESX_REBLASTS, MIXPANEL_SEARCH } from '../../../Constants';
import resx from '../../../utilities/resx';
import Mixpanel from '../../../API/Mixpanel';
import sfarNeighborhoodsList from '../../../data/sfarNeighborhoodsList';

const reducer = (state, action) => {
    const newState = _clone(state);

    switch (action.type) {
        case 'init':
            newState.AssociatedContentType = '';
            newState.SearchText = '';
            newState.ReferralType = '';
            newState.ListingMarketStatus = '';
            newState.NeighbourHood = '';
            return newState;
        case 'setAssociatedContentType':
            newState.AssociatedContentType = action.val;
            newState.ReferralType = '';
            newState.ListingMarketStatus = '';
            newState.NeighbourHood = '';
            return newState;
        case 'setSearchText':
            newState.SearchText = action.val;
            return newState;
        case 'setReferralType':
            newState.ReferralType = action.val;
            return newState;
        case 'setListingMarketStatus':
            newState.ListingMarketStatus = action.val;
            return newState;
        case 'setNeighbourHood':
            newState.NeighbourHood = action.val;
            return newState;
        default:
            return state;
    }
};

const SearchFeed = props => {
    const [state, setState] = useReducer(reducer, {
        AssociatedContentType: '',
        SearchText: '',
        ReferralType: '',
        ListingMarketStatus: '',
        NeighbourHood: '',
        GroupId: _path(['firmorgroup', 'GroupId'], props)
    });
    const [showClear, setShowClear] = useState(false);
    const [updateSelect, setUpdateSelect] = useState(0);

    const SaveMixpanel = () => {
        const mixpanelPayload = {
            type: 'feed search',
            source: 'manual',
            from: 'activity-feed',
            'search text': state.SearchText,
            'search feed': _path(['firmorgroup', 'GroupUniqueName'], props),
            'search feed name': _path(['firmorgroup', 'GroupName'], props)
        };
        switch (state.AssociatedContentType) {
            case '3':
                mixpanelPayload.category = 'Posts';
                break;
            case '1':
                mixpanelPayload.category = 'Listings';
                break;
            case '6':
                mixpanelPayload.category = 'Referrals';
                break;
            default:
                mixpanelPayload.category = 'All';
                break;
        }
        if (state.AssociatedContentType === '1') {
            switch (state.ListingMarketStatus) {
                case '0':
                    mixpanelPayload['search mls market status'] = 'On Market';
                    break;
                case '1':
                    mixpanelPayload['search mls market status'] = 'Pre Market';
                    break;
                default:
                    mixpanelPayload['search mls market status'] = 'All';
                    break;
            }
        }
        if (state.AssociatedContentType === '1' && state.NeighbourHood) {
            mixpanelPayload['search mls neighborhood'] = state.NeighborHood;
        }
        if (state.AssociatedContentType === '6') {
            switch (state.ReferralType) {
                case '2':
                    mixpanelPayload['search leads type'] = 'Referral';
                    break;
                case '3':
                    mixpanelPayload['search leads type'] = 'Buyerneed';
                    break;
                default:
                    mixpanelPayload['search leads type'] = 'All';
                    break;
            }
        }
        Mixpanel.add(MIXPANEL_SEARCH, mixpanelPayload);
    };

    const onClickSearch = () => {
        props.doSearchFeed(state);
        setShowClear(true);
        SaveMixpanel();
    };

    // run search if user updates a filter
    useEffect(
        () => {
            if (updateSelect !== 0) {
                onClickSearch();
            }
        },
        [updateSelect]
    );

    const onClickClear = () => {
        props.doClearSearch();
        setState({ type: 'init' });
        setShowClear(false);
    };

    const isSFAR = () => {
        const groupUniqueName = _path(['firmorgroup', 'GroupUniqueName'], props);
        const origin = _path(['RESAAS', 'User2', 'Origin'], window);
        // not a MLS
        if (!groupUniqueName || !origin) {
            return false;
        }
        if (origin.toLowerCase() !== 'sfar') {
            return false;
        }
        if (groupUniqueName.toLowerCase() !== 'sfar') {
            return false;
        }
        return true;
    };

    const showMLSListingFilters = () => {
        const groupUniqueName = _path(['firmorgroup', 'GroupUniqueName'], props);
        const origin = _path(['RESAAS', 'User2', 'Origin'], window);

        // not a MLS
        if (!groupUniqueName || !origin) {
            return false;
        }
        // not a listing
        if (state.AssociatedContentType !== '1') {
            return false;
        }
        // skip for following mls
        if (groupUniqueName === 'bareis' || groupUniqueName === 'riar') {
            return false;
        }

        // special case for sfar
        if (isSFAR()) {
            return true;
        }

        // is on mls feed
        if (origin.toLowerCase() === groupUniqueName.toLowerCase()) {
            return true;
        }
        return false;
    };


    return (
        <div className="re-feedssearch-searchbar formV2">
            <div className="formV2-inputSelectButtonCombo">
                <div className="formV2-inputSelectButtonCombo-select">
                    <label htmlFor="re-feedssearch-contentType-dropdown">
                        {resx(RESX_GLOBAL, 'SEARCH_CONTENT_TYPE')}
                    </label>
                    <select
                        id="re-feedssearch-contentType-dropdown"
                        className="re-feedssearch-contentType-dropdown"
                        data-testid="feedssearch-contentType-dropdown"
                        name="AssociatedContentType"
                        value={state.AssociatedContentType}
                        onChange={e => {
                            setState({ type: 'setAssociatedContentType', val: e.currentTarget.value });
                            // set listingMarkertStatus to 1 only for bareis when search the listing.
                            // it is rely on the page reload to clear the value.
                            const groupUniqueName = _path(['firmorgroup', 'GroupUniqueName'], props);
                            if (groupUniqueName === 'bareis' && e.currentTarget.value === '1') {
                                setState({ type: 'setListingMarketStatus', val: 1 });
                            }
                            setUpdateSelect(prev => prev + 1);
                        }}
                    >
                        <option value="">{resx(RESX_GLOBAL, 'ALL_TEXT')}</option>
                        <option value="3">{resx(RESX_GLOBAL, 'POSTS')}</option>
                        <option value="1">{resx(RESX_GLOBAL, 'LISTINGS')}</option>
                        <option value="6">{resx(RESX_GLOBAL, 'REFERRALS_TEXT')}</option>
                    </select>
                </div>
                <div className="formV2-inputSelectButtonCombo-input">
                    <label htmlFor="re-feedssearch-input">{resx(RESX_REBLASTS, 'SEARCH')}</label>
                    <input
                        type="text"
                        id="re-feedssearch-input"
                        className="re-loadmore-input re-input-clear"
                        name="SearchText"
                        placeholder={resx(RESX_REBLASTS, 'SEARCH')}
                        value={state.SearchText}
                        onChange={e => {
                            setState({ type: 'setSearchText', val: e.currentTarget.value });
                        }}
                    />
                    <a className="hide re-icon re-icon-x re-icon-sm re-icon-grey-light" />
                </div>
                <div className="formV2-inputSelectButtonCombo-button">
                    <label>-</label>
                    <button
                        type="button"
                        id="re-feedssearch-searchbtn"
                        className="re-feedssearch-searchbtn re-icon re-icon-sm re-icon-search"
                        onClick={onClickSearch}
                    />
                </div>
            </div>

            {/* Leads Filter */}
            {state.AssociatedContentType === '6' ? (
                <div className="re-grid-container">
                    <div className="re-grid-row">
                        <div className="re-grid-col-xs-12">
                            <label htmlFor="re-feedssearch-leads-dropdown">{resx(RESX_GLOBAL, 'LEADS_TYPE')}</label>
                            <select
                                id="re-feedssearch-leads-dropdown"
                                name="ReferralType"
                                value={state.ReferralType}
                                onChange={e => {
                                    setState({ type: 'setReferralType', val: e.currentTarget.value });
                                    setUpdateSelect(prev => prev + 1);
                                }}
                            >
                                <option value="">{resx(RESX_GLOBAL, 'REFERRALS_AND_BUYER_NEEDS')}</option>
                                <option value="2">{resx(RESX_GLOBAL, 'REFERRAL_LEADSVIEW_REFERRALS')}</option>
                                <option value="3">{resx(RESX_GLOBAL, 'BUYER_NEEDS')}</option>
                            </select>
                        </div>
                    </div>
                </div>
            ) : null}

            {/* Listings Filter */}
            {showMLSListingFilters() ? (
                <div className="re-grid-container">
                    <div className="re-grid-row">
                        <div className="re-grid-col-xs-12">
                            <label htmlFor="re-feedssearch-marketType-dropdown">
                                {resx(RESX_GLOBAL, 'MARKET_STATUS')}
                            </label>
                            <select
                                id="re-feedssearch-marketType-dropdown"
                                name="ListingMarketStatus"
                                value={state.ListingMarketStatus}
                                onChange={e => {
                                    setState({ type: 'setListingMarketStatus', val: e.currentTarget.value });
                                    setUpdateSelect(prev => prev + 1);
                                }}
                            >
                                <option value="">{resx(RESX_GLOBAL, 'PRE_MARKET_AND_ON_MARKET')}</option>
                                <option value="1">{resx(RESX_GLOBAL, 'PRE_MARKET')}</option>
                                <option value="0">{resx(RESX_GLOBAL, 'ON_MARKET')}</option>
                            </select>
                        </div>

                        {isSFAR() ? (
                            <div className="re-grid-col-xs-12">
                                <label htmlFor="re-feedssearch-neighborhood-dropdown">
                                    {resx(RESX_REBLASTS, 'NEIGHBORHOODS')}
                                </label>
                                <select
                                    id="re-feedssearch-neighborhood-dropdown"
                                    name="NeighbourHood"
                                    value={state.NeighbourHood}
                                    onChange={e => {
                                        setState({ type: 'setNeighbourHood', val: e.currentTarget.value });
                                        setUpdateSelect(prev => prev + 1);
                                    }}
                                >
                                    {sfarNeighborhoodsList.map(item => {
                                        if (item.optgroup) {
                                            return (
                                                <optgroup key={item.label} label={item.label}>
                                                    {item.fields.map(subItem => (
                                                        <option
                                                            key={subItem.value || subItem.key}
                                                            value={subItem.label}
                                                        >
                                                            {subItem.label}
                                                        </option>
                                                    ))}
                                                </optgroup>
                                            );
                                        }
                                        return (
                                            <option
                                                key={item.value || item.key}
                                                value={item.value === '' ? '' : item.label}
                                            >
                                                {item.label}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        ) : null}
                    </div>
                </div>
            ) : null}

            {/* Clear Search */}
            {showClear ? (
                <div className="re-feedssearch-title" style={{ display: 'flex' }}>
                    <div className="re-feedssearch-title-text">{resx(RESX_GLOBAL, 'SEARCH_RESULTS')}</div>
                    <a
                        className="re-feedssearch-returntofeed re-btn re-btn-small"
                        data-mixpanel-name="Intent"
                        data-mixpanel-type="return to feed from search"
                        data-mixpanel-from="activity-feed"
                        onClick={onClickClear}
                    >
                        {resx(RESX_REBLASTS, 'CLEAR_SEARCH')}
                    </a>
                </div>
            ) : null}
        </div>
    );
};

SearchFeed.propTypes = {
    firmorgroup: PropTypes.object.isRequired,
    doSearchFeed: PropTypes.func.isRequired,
    doClearSearch: PropTypes.func.isRequired
};

export default SearchFeed;
